module.exports = __webpack_public_path__ + "static/img/vr.1d7239f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/vr.png
// module id = F8aJ
// module chunks = 23